import { MouseEvent } from "react";
import {
  StyledLinkSpan,
  StyledTextSpan,
} from "src/components/application/styled-components/StyledConsentSpan";

export const PRIVACY_POLICY_URL = "https://calebandbrown.com/privacy-policy/";
export const ENTRUST_TERMS_URL = "https://onfido.com/terms-of-service/";
export const ENTRUST_PRIVACY_URL = "https://onfido.com/privacy/";

/** A link inside a checkbox label must not toggle the checkbox. */
const keepCheckbox = (event: MouseEvent): void => event.stopPropagation();

const ExternalLink = ({ href, children }: { href: string; children: string }): JSX.Element => (
  <StyledLinkSpan href={href} target="_blank" rel="noreferrer" onClick={keepCheckbox}>
    {children}
  </StyledLinkSpan>
);

/**
 * CR1 — the DVS consent sentence, verbatim from compliance (2026-10-08). The
 * backend pins the same text as ADHOC_KYC_CONSENT_WORDING under wording
 * version v1.1; change both together and bump the version.
 */
export const DvsConsentWording = (): JSX.Element => (
  <StyledTextSpan data-testid="adhoc-kyc-consent-wording">
    I confirm that I am authorised to provide the personal details presented and I consent to my
    information being checked with the document issuer or official record holder via third party
    systems for the purpose of confirming my identity, and as per the Caleb &amp; Brown{" "}
    <ExternalLink href={PRIVACY_POLICY_URL}>Privacy Policy</ExternalLink>.
  </StyledTextSpan>
);

/**
 * CR2 — the biometric notice and consent, verbatim from compliance
 * (2026-10-22). Rendered in front of the Onfido SDK on the stale branch only;
 * consent is given by the "Consent and continue" button, so there is no
 * checkbox. The backend pins the same text as
 * ADHOC_KYC_BIOMETRIC_CONSENT_WORDING under version v1.1; change both
 * together and bump the version. The confirmed branch never collects
 * biometrics.
 */
export const BiometricConsentWording = (): JSX.Element => (
  <StyledTextSpan data-testid="adhoc-kyc-biometric-consent-wording">
    By clicking the button below, you consent to Caleb &amp; Brown collecting a short video of your
    face and the photo on your government-issued ID to create a facial template (together, your
    biometric information) to verify your identity, meet our legal obligations, and prevent identity
    fraud, in accordance with our{" "}
    <ExternalLink href={PRIVACY_POLICY_URL}>Privacy Policy</ExternalLink>.
    <br />
    <br />
    Onfido Pte Ltd, part of Entrust, our service provider, will collect and process this
    information, on our behalf, in accordance with its{" "}
    <ExternalLink href={ENTRUST_TERMS_URL}>Terms of Service</ExternalLink> and{" "}
    <ExternalLink href={ENTRUST_PRIVACY_URL}>Product Privacy Notice</ExternalLink>.
    <br />
    <br />
    If you decline, we will not be able to verify your identity or continue to provide certain
    services.
  </StyledTextSpan>
);
